export const contentContainer = {
  width: "100%",
  padding: "40px",
  display: "flex",
  flexDirection: "column",
  zIndex: 100,
};

export const modalTitle = {
  textTransform: "uppercase",
  paddingBottom: "20px",
  borderBottom: "solid 4px",
  borderColor: "grey9",
  marginBottom: "20px",
  lineHeight: "30px",
};

export const modalTextContent = {
  fontFamily: "Roboto",
  fontWeight: "300",
  fontStyle: "normal",
  fontSize: "14px",
  lineHeight: "129%",
  letterSpacing: "0.05em",

  "& .recommendationsCopy": {
    marginTop: "0px",
  },

  "& .recommendationWrapper": {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    marginTop: "20px",
  },

  "& .recommendationType": {
    margin: 0,
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: "24px",
    letterSpacing: "5%",
  },

  "& .recommendationVariants": {
    display: "flex",
    gap: "10px",

    "& > *": {
      margin: 0,
      padding: 0,
    },
  },

  "& ul": {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    listStyleType: "none",

    "& li": {
      fontWeight: "700",
      textTransform: "uppercase",
    },

    "& li:not(:last-child)::after": {
      content: '","',
    },
  },
};
